export const STEP_QUERY_STRING_NAME = 'step';

export const SELECT_PRODUCT_STEP = 'select-product';

export const LOGIN_REGISTER_STEP = 'register-login';

export const showWarrantyDateLabel = (text, date) => {
  return text.replace('{date}', date);
};
